module.exports = __webpack_public_path__ + "3aec0ca671c6fe312533efdd2370f511.svg";